import { render, staticRenderFns } from "./UsersProfileIntegration.vue?vue&type=template&id=4eb3a5dd&"
import script from "./UsersProfileIntegration.vue?vue&type=script&lang=js&"
export * from "./UsersProfileIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports